// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { linkListStyles } from "@synd/Overrides/Widgets/Basic/LinkList";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { css } from "styled-components";

linkListStyles.linkListWrapper = {};

linkListStyles.titleWrapper = {
    css: css`
        font-weight: ${fontConfig.weight.semiBold};
        text-transform: uppercase;
    `,
};

linkListStyles.linkWrapper = {
    css: css`
        display: flex;
        row-gap: 8px;
        column-gap: ${({ direction }: any) => (direction === "vertical" ? 12 : 22)}px;
        flex-direction: ${({ direction }: any) => (direction === "vertical" ? "column" : "row")};
        ${TypographyStyle} {
            font-size: ${fontConfig.xSmallSingleLine.size}px;
            line-height: ${fontConfig.xSmallSingleLine.lineHeight};
        }
        flex-wrap: wrap;
    `,
};

linkListStyles.title = {
    variant: "h6",
    forwardAs: "h3",
    css: css`
        &:empty {
            display: none;
        }
    `,
};

linkListStyles.infoZoneWrapper = {
    css: css`
        margin-bottom: 12px;
    `,
};
